import { Form, Input } from 'antd'
import { bool, func, object, shape, string } from 'prop-types'
import React, { useCallback } from 'react'
import InfoField from 'components/infoField'
import InputMask from 'react-input-mask'
import { validateCep } from 'utils'
import { useFocusCallback } from 'utils/fieldHooks'

const CepField = ({
	pageFieldsData,
	className,
	onChange,
	onFocus,
	first,
	inputValue,
	disabled,
	visible,
}) => {
	const { label, variable, type, id, info, list, optional } = pageFieldsData
	const isObj = typeof variable === 'object'
	const varname = isObj ? variable.name : variable
	const name = id !== undefined ? `${varname}_${id}` : varname

	const changeCallback = useCallback(
		(e) => (onChange ? onChange(e.target.value) : undefined),
		[onChange]
	)

	const focusCallback = useFocusCallback(onFocus, pageFieldsData)

	return (
		<Form.Item
			key={name}
			name={list !== undefined ? [list, name] : name}
			label={<InfoField label={label} info={info} />}
			type={type}
			className={className}
			hasFeedback
			rules={
				visible && [
					() => ({
						validator(rule, value) {
							if (!optional) {
								if (!value) {
									return Promise.reject('Este campo é obrigatório')
								}
								if (!validateCep(value, optional)) {
									return Promise.reject('Cep inválido')
								}
							} else if (value.length > 0 && !validateCep(value)) {
								return Promise.reject('Cep inválido')
							}
							return Promise.resolve()
						},
					}),
				]
			}
			colon={false}
			initialValue={inputValue}>
			<InputMask
				mask="99999-999"
				maskChar={null}
				onChange={changeCallback}
				onFocus={focusCallback}>
				{() => <Input autoFocus={first} placeholder="" disabled={disabled} />}
			</InputMask>
		</Form.Item>
	)
}

CepField.propTypes = {
	pageFieldsData: shape({
		label: string.isRequired,
		variable: object.isRequired,
		type: string.isRequired,
		info: string,
	}).isRequired,
	className: string,
	onChange: func,
	onFocus: func,
	first: bool,
	inputValue: string,
	disabled: bool,
	visible: bool,
}

CepField.defaultProps = {
	visible: true,
}

export default CepField
